import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect } from "../../../adapter-vue";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { isPC, isH5, isUniFrameWork } from "../../../utils/env";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  show: {
    type: Boolean,
    default: false,
  },
  isHeaderShow: {
    type: Boolean,
    default: true,
  },
  isFooterShow: {
    type: Boolean,
    default: true,
  },
  background: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: "",
  },
  center: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:show", "submit"],
  setup(__props, { emit }) {

const props = __props

const clickType = {
  OUTSIDE: 'outside',
  INSIDE: 'inside'
}


const showDialog = ref(false);
const isHeaderShowDialog = ref(true);
const isFooterShowDialog = ref(true);
const backgroundDialog = ref(true);
const showTitle = ref("");

watchEffect(() => {
  showDialog.value = props.show;
  showTitle.value = props.title;
  isHeaderShowDialog.value = props.isHeaderShow;
  isFooterShowDialog.value = props.isFooterShow;
  backgroundDialog.value = props.background;
})



const toggleView = (type: string) => {
  if (type === clickType.OUTSIDE) {
    close();
  }
};

const close = () => {
  showDialog.value = !showDialog.value;
  emit("update:show", showDialog.value);
}

const submit = () => {
  emit("submit");
  close();
};

return { __sfc: true,clickType, props, showDialog, isHeaderShowDialog, isFooterShowDialog, backgroundDialog, showTitle, emit, toggleView, close, submit, TUITranslateService, isPC, isH5, isUniFrameWork }
}

})